"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPropertyFormatsMap = buildPropertyFormatsMap;
exports.getAmountFormat = getAmountFormat;
exports.getUserAmountFormatFieldKey = getUserAmountFormatFieldKey;
exports.createUserAmountFieldsMap = createUserAmountFieldsMap;
exports.createFieldsDefaultsMap = createFieldsDefaultsMap;
exports.createQuantityDefaultsMap = createQuantityDefaultsMap;
exports.convertToMeasureSystemString = convertToMeasureSystemString;
exports.convertToMeasureSystemInt = convertToMeasureSystemInt;
exports.isAmount = isAmount;
const uom_1 = require("@genesys/uom");
const property_1 = require("@genesys/property");
function buildPropertyFormatsMap(quantityDefaults, fieldDefaults, userAmountFields, measureSystem, screenAmountProfileFieldGroup, properties) {
    const propertyFormats = property_1.PropertyValueSet.getPropertyNames(properties).reduce((soFar, propertyName) => {
        const amount = property_1.PropertyValueSet.getAmount(propertyName, properties);
        if (!amount) {
            return soFar;
        }
        const amountFormat = getAmountFormat(quantityDefaults, fieldDefaults, userAmountFields, measureSystem, screenAmountProfileFieldGroup, propertyName, amount);
        soFar[propertyName] = amountFormat;
        return soFar;
    }, {});
    return propertyFormats;
}
function getAmountFormat(quantityDefaults, fieldDefaults, userAmountFields, measureSystemKey, fieldGroup, fieldName, amountOrQuantity) {
    const key = `${convertToMeasureSystemString(measureSystemKey)}_${fieldGroup}_${fieldName}`;
    const userDefault = userAmountFields[key];
    if (userDefault) {
        return {
            unit: userDefault.unit,
            decimalCount: userDefault.decimalCount,
            userDefined: true
        };
    }
    const fieldDefault = fieldDefaults[key];
    if (fieldDefault) {
        return {
            unit: fieldDefault.unit,
            decimalCount: fieldDefault.decimalCount,
            userDefined: false
        };
    }
    const quantity = isAmount(amountOrQuantity)
        ? amountOrQuantity.unit.quantity
        : amountOrQuantity;
    const quantityDefault = quantityDefaults[quantity] && quantityDefaults[quantity][measureSystemKey];
    if (quantityDefault) {
        return {
            unit: quantityDefault.unit,
            decimalCount: quantityDefault.decimalCount,
            userDefined: false
        };
    }
    if (isAmount(amountOrQuantity)) {
        const unit = amountOrQuantity.unit;
        const format = uom_1.Format.getUnitFormat(unit);
        // last resort
        return {
            unit: unit,
            decimalCount: format.decimalCount,
            userDefined: false
        };
    }
    const units = uom_1.Format.getUnitsForQuantity(amountOrQuantity);
    if (units.length > 0) {
        const unitFormat = uom_1.Format.getUnitFormat(units[0]);
        return {
            unit: units[0],
            decimalCount: unitFormat !== undefined ? unitFormat.decimalCount : 2,
            userDefined: false
        };
    }
    throw new Error("Unable to determine unit information");
}
function getUserAmountFormatFieldKey(measureSystem, fieldGroup, fieldName) {
    const key = `${convertToMeasureSystemString(measureSystem)}_${fieldGroup}_${fieldName}`;
    return key;
}
function createUserAmountFieldsMap(userAmountFields) {
    return userAmountFields.reduce((soFar, current) => {
        try {
            const key = getUserAmountFormatFieldKey(current.measureSystem, current.fieldGroup, current.fieldName);
            const unit = uom_1.Serialize.stringToUnit(current.unit);
            if (unit === undefined) {
                console.warn("Unknown unit " + current.unit);
                return soFar;
            }
            const quantityFormat = {
                unit,
                decimalCount: current.decimalCount !== undefined ? current.decimalCount : 2,
                userDefined: true
            };
            soFar[key] = quantityFormat;
        }
        catch (error) {
            console.warn(error);
        }
        return soFar;
    }, {});
}
function createFieldsDefaultsMap(fieldDefaults) {
    return fieldDefaults.reduce((soFar, current) => {
        try {
            const key = `${convertToMeasureSystemString(current.measureSystem)}_${current.fieldGroup}_${current.fieldName}`;
            const quantityFormat = {
                unit: uom_1.Serialize.stringToUnit(current.unit),
                decimalCount: current.decimalCount !== undefined ? current.decimalCount : 2,
                userDefined: false
            };
            soFar[key] = quantityFormat;
        }
        catch (error) {
            console.warn(error);
        }
        return soFar;
    }, {});
}
function createQuantityDefaultsMap(quantityDefaults) {
    return quantityDefaults.reduce((soFar, current) => {
        try {
            const quantityFormat = {
                unit: uom_1.Serialize.stringToUnit(current.unit),
                decimalCount: current.decimalCount,
                userDefined: false
            };
            if (soFar[current.quantity]) {
                soFar[current.quantity][current.measureSystem] = quantityFormat;
            }
            else {
                soFar[current.quantity] = { [current.measureSystem]: quantityFormat };
            }
        }
        catch (error) {
            console.warn(error);
        }
        return soFar;
    }, {});
}
function convertToMeasureSystemString(measureSystem) {
    if (measureSystem === 1) {
        return "SI";
    }
    if (measureSystem === 2) {
        return "IP";
    }
    throw new Error("Invalid measure system");
}
function convertToMeasureSystemInt(measureSystem) {
    if (measureSystem === "SI") {
        return 1;
    }
    if (measureSystem === "IP") {
        return 2;
    }
    throw new Error("Invalid measure system");
}
function isAmount(value) {
    if (typeof value === "string") {
        return false;
    }
    return true;
}
//# sourceMappingURL=functions.js.map